import React, { useMemo } from 'react'
import Tabs from '@mui/material/Tabs'
import { useTheme } from '@mui/material/styles'
import { useIsMobileLayout } from '../../utils/hooks/useIsMobileLayout'
import { useTabNavContext } from '../../utils/providers/tabNavContext'
import { useTabNavLink } from './TabNavLink'
import {
  getHeaderPrimaryTabsSx,
  getHeaderPrimaryTabSx,
  headerHeight,
  mobileHeaderActionsRowHeight,
} from './tabNavStyles'
import { useHeaderColorScheme } from '../../utils/providers/headerColorContext'

const LayoutHeaderPrimaryNav: React.FC = () => {
  const { primaryItems } = useTabNavContext()
  const { scheme } = useHeaderColorScheme()
  const theme = useTheme()
  const isSmallScreen = useIsMobileLayout()
  const navHeight = isSmallScreen ? mobileHeaderActionsRowHeight : headerHeight
  const primaryTabSx = useMemo(
    () => ({
      ...getHeaderPrimaryTabSx(scheme),
      minHeight: navHeight,
      ...(isSmallScreen && { padding: '0 1.2rem' }),
    }),
    [isSmallScreen, navHeight, scheme]
  )
  const { currentRouteIndex, displayableItems } = useTabNavLink(primaryItems, primaryTabSx)
  const primaryTabsSx = useMemo(
    () => ({
      ...getHeaderPrimaryTabsSx(scheme),
      display: 'flex',
      minHeight: navHeight,
      width: '100%',
      ...(isSmallScreen && { height: navHeight }),
    }),
    [isSmallScreen, navHeight, scheme]
  )

  if (!displayableItems.length) return null

  return (
    <Tabs
      value={currentRouteIndex}
      data-testid="tabnavlink"
      scrollButtons="auto"
      variant="scrollable"
      textColor="inherit"
      sx={primaryTabsSx}
    >
      {displayableItems}
    </Tabs>
  )
}

export default LayoutHeaderPrimaryNav
